import React from 'react'
import PropTypes from 'prop-types'

const selectStyle = {
    height: '34px',
    width: '100%',
    backgroundColor: '#fff',
    border: 0,
    outline: 'none',
    fontWeight: 400,
}

const FilterSelect = ({ filterSetting, changeFilter, columnName, filter }) => {
    if (!filterSetting || filterSetting.type !== 'select') {
        return null
    }
    return (
        <select
            style={selectStyle}
            onChange={(event) => {
                changeFilter(columnName, event.currentTarget.value)
            }}
            value={filter[columnName] || ''}
        >
            <option value="">All</option>
            {filterSetting.valueList.map(({ id, value }) => {
                return <option key={id} value={id}>{value}</option>
            })}
        </select>
    )
}

FilterSelect.propTypes = {
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    columnName: PropTypes.string.isRequired,
    filterSetting: PropTypes.object,
}

export default FilterSelect



// WEBPACK FOOTER //
// ./src/modules/table/component/FilterSelect.js